<template>
  <v-layout row wrap>
    <v-dialog v-model="value" persistent max-width="1200px">
      <v-card class="px-3">
        <v-card-title primary-title class="title">{{presTitle}}</v-card-title>
        <v-card-text class="pa-0">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container grid-list-xs fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-textarea rows="3" label="Diagnoses" v-model="newPres.diagnoses"></v-textarea>
                </v-flex>

                <v-flex xs12>
                  <div class="d-flex">
                    <v-autocomplete
                      :items="drugGroups"
                      single-line
                      hide-details
                      box
                      hide-selected
                      item-text="name"
                      item-value="id"
                      label="Search on drug groups"
                      dense
                      @change="addDrugGroup"
                      return-object
                    ></v-autocomplete>
                    <v-autocomplete
                      class="ml-2"
                      :items="drugs"
                      single-line
                      hide-details
                      box
                      hide-selected
                      item-text="name"
                      item-value="id"
                      label="Search on drug"
                      dense
                      @change="addDrug"
                      return-object
                    ></v-autocomplete>
                  </div>
                  <v-data-table :headers="headers" :items="newPres.drugs" hide-actions>
                    <template slot="items" slot-scope="props">
                      <td>{{ props.index + 1 }}</td>
                      <td>{{ props.item.name }}</td>
                      <td>
                        <input class="pa-1" v-model="props.item.route" />
                      </td>
                      <td>
                        <input class="pa-1" v-model="props.item.duration" />
                      </td>
                      <td>
                        <input class="pa-1" v-model="props.item.usage" />
                      </td>
                      <td>
                        <input class="pa-1" type="number" v-model="props.item.quantity" />
                      </td>
                      <td>
                        <input class="pa-1" v-model="props.item.type" />
                      </td>
                      <td>
                        <v-icon color="error" @click="removeDrug(props.item)">mdi-close</v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>

                <v-flex xs12 class="text-xs-right mt-3">
                  <v-btn flat @click="clean">Close</v-btn>

                  <v-btn
                    class="mx-0"
                    :loading="loading"
                    color="primary"
                    @click="submit"
                    :disabled="!valid"
                  >Save</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    patientId: {
      type: Number,
      required: true
    },
    edit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      valid: true,
      requiredRule: v => !!v || "This field is required.",
      loading: false,
      newPres: {
        diagnoses: "",
        drugs: []
      },
      headers: [
        { text: "#", value: "id", sortable: false },
        { text: "Drug Name", value: "name", sortable: false },
        { text: "Route", value: "route", sortable: false },
        { text: "Duration", value: "duration", sortable: false },
        { text: "Usage", value: "usage", sortable: false },
        { text: "Quantity", value: "quantity", sortable: false, width: "50" },
        { text: "Type", value: "type", sortable: false },
        { text: "", value: "id", sortable: false, width: "50" }
      ]
    };
  },
  computed: {
    presTitle() {
      return this.newPres.id ? "Edit Prescription" : "New Prescription";
    },
    ...mapGetters({
      drugs: "base/drugs",
      drugGroups: "base/drugGroups"
    }),
    user() {
      return this.$store.getters["auth/user"];
    }
  },
  methods: {
    removeDrug(drug) {
      this.newPres.drugs.splice(this.newPres.drugs.indexOf(drug), 1);
    },
    addDrugGroup(group) {
      for (const drug of group.drugs) {
        this.addDrug(drug);
      }
    },
    addDrug(drug) {
      this.newPres.drugs.push({
        id: drug.id,
        name: drug.name,
        route: drug.route,
        duration: drug.duration,
        usage: drug.usage,
        quantity: 1,
        type: drug.type,
        price: drug.price
      });
    },
    clean() {
      this.newPres = { diagnoses: "", drugs: [] };
      this.loading = false;
      this.$emit("input", false);
      this.$refs.form.reset();
    },
    submit() {
      if (this.newPres.drugs.length === 0) return;

      const total = this.newPres.drugs.reduce((prev, curr) => {
        return (prev += curr.price * curr.quantity);
      }, 0);

      this.loading = true;

      let data = {
        patient_id: this.patientId,
        doctor_id: this.user.id,
        diagnoses: this.newPres.diagnoses,
        drugs: this.newPres.drugs,
        total: total
      };

      if (this.newPres.id) data.id = this.newPres.id;

      this.axios
        .post(`/api/prescriptions`, data)
        .then(resp => {
          this.$emit("refresh");
        })
        .finally(() => this.clean());
    }
  },
  mounted() {
    this.$store.dispatch("base/loadDrugs");
    this.$store.dispatch("base/loadDrugGroups");
  }
};
</script>

<style lang="scss" scoped>
</style>